import React, { useState } from 'react';
import { LOCATIONS, MUSCLE_GROUPS, generateRoutine } from '../../data/routineData';
import './RoutineStyles.css'; // We will create this next

function RoutineBuilder({ onRoutineGenerated }) {
    const [location, setLocation] = useState('gym');
    const [focus, setFocus] = useState('glutes');
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGenerate = () => {
        setIsGenerating(true);

        // Simulate API/Calculation delay
        setTimeout(() => {
            const routine = generateRoutine({ location, focus });
            onRoutineGenerated(routine);
            setIsGenerating(false);
        }, 1500);
    };

    return (
        <div className="routine-builder-card">
            <div className="builder-header">
                <h3 className="builder-title">Configura tu sesión</h3>
                <p className="builder-subtitle">Adapta el entrenamiento a tu día.</p>
            </div>

            <div className="builder-section">
                <label className="builder-label">¿Dónde entrenas hoy?</label>
                <div className="toggle-group">
                    {LOCATIONS.map((loc) => (
                        <button
                            key={loc.id}
                            type="button"
                            className={`toggle-option ${location === loc.id ? 'active' : ''}`}
                            onClick={() => setLocation(loc.id)}
                        >
                            <span className="toggle-icon">{loc.icon}</span>
                            <span className="toggle-label">{loc.label}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="builder-section">
                <label className="builder-label">Objetivo principal</label>
                <div className="focus-grid">
                    {MUSCLE_GROUPS.map((group) => (
                        <button
                            key={group.id}
                            type="button"
                            className={`focus-card ${focus === group.id ? 'active' : ''}`}
                            onClick={() => setFocus(group.id)}
                            style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${group.image})` }}
                        >
                            <span className="focus-name">{group.label}</span>
                            {focus === group.id && <span className="focus-check">✓</span>}
                        </button>
                    ))}
                </div>
            </div>

            <div className="builder-actions">
                <button
                    className="pill-button pill-button-primary full-width"
                    onClick={handleGenerate}
                    disabled={isGenerating}
                >
                    {isGenerating ? 'Preparando rutina...' : 'Comenzar Entrenamiento'}
                </button>
            </div>
        </div>
    );
}

export default RoutineBuilder;
